import {
  axiosInstance,
  clearAuthHeaders,
  type CustomResponseFormat,
} from "api/instance";
import { COACH_AUTH_MODE, setCoachToken } from "api/coachAuth";
import type { UserType } from "recoil/userAtom";

/**
 * JWT 세션 시작 (코치 웹·유저 PC 웹 공통).
 * 액세스 토큰은 메모리(coachAuth)에만 두고, /user/detail 로 받은 프로필에서 토큰 필드를 뺀 뒤
 * authMode "jwt" 표식을 붙여 돌려준다. 호출부가 이것을 userAtom 에 저장한다 — localStorage 에 토큰이 남지 않는다.
 * 실패하면 메모리 토큰을 비우고 throw.
 */
export async function startJwtSession(
  accessToken: string,
  sessionKind?: "pcweb"
): Promise<UserType> {
  // 레거시 헤더가 남아 있으면 서버가 그걸 먼저 보므로 먼저 비운다.
  clearAuthHeaders();
  setCoachToken(accessToken);
  try {
    const detail =
      await axiosInstance.get<CustomResponseFormat<UserType>>("/user/detail");
    const profile = detail?.result;
    if (!profile) throw new Error("no profile");
    const { accessToken: _omit, ...rest } = profile;
    return {
      ...rest,
      authMode: COACH_AUTH_MODE,
      ...(sessionKind ? { sessionKind } : {}),
    };
  } catch (e) {
    setCoachToken(null);
    throw e;
  }
}
